// @flow

import styled from 'styled-components'

export default styled.div`
  background: ${props => props.theme.background};
  text-align: center;
  height: 100%;
  overflow: hidden;
`



// WEBPACK FOOTER //
// ./src/Components/AppContainer.js